export const defaultNotification = { autoDismiss: false, actionButton: { show: false }, closeButton: { show: false } };
export const defaultClosableNotification = Object.assign(Object.assign({}, defaultNotification), { closeButton: { show: true } });
